/* eslint-disable no-restricted-globals */
// ─────────────────────────────────────────────────────────────────────────
// SERGA // PERSONAL OS — small text helpers shared across HUD surfaces.
// `escapeHtml` makes arbitrary text safe to drop into innerHTML; `linkify`
// escapes text AND turns bare URLs into domain-only clickable anchors
// (https://www.example.com/long/path → example.com), keeping the full URL in
// href + title. Used by the FEED tray (Mastodon stream + Today's Focus card).
// ─────────────────────────────────────────────────────────────────────────

export function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// ── relative-time helpers (shared by the FEED tray's FOCUS + STREAM) ───────
// minutes → compact label ("now" / "5m" / "2h" / "1d")
export function agoText(m) {
  if (m < 1) return 'now';
  if (m < 60) return Math.round(m) + 'm';
  if (m < 1440) return Math.round(m / 60) + 'h';
  return Math.round(m / 1440) + 'd';
}
// minutes since an ISO timestamp (or null if unparseable)
export function minsSince(iso) {
  const t = Date.parse(iso);
  return Number.isFinite(t) ? Math.max(0, (Date.now() - t) / 60000) : null;
}
// a stream post carries either a live `createdAt` (ISO) or a fixture `agoMin`
export function postAgo(t) {
  const m = t.createdAt != null ? minsSince(t.createdAt) : t.agoMin;
  return agoText(m == null ? 0 : m);
}

// bare http(s) URL run (stop at whitespace or an angle bracket)
const URL_RE = /(https?:\/\/[^\s<]+)/g;
// trailing punctuation that's almost never part of the URL itself
const TRAIL_RE = /[).,;:!?'"\]]+$/;

function anchor(url) {
  let host;
  try { host = new URL(url).hostname.replace(/^www\./, ''); }
  catch (e) { host = url; }
  return `<a class="th-link" href="${escapeHtml(url)}" target="_blank" rel="noreferrer"` +
    ` title="${escapeHtml(url)}">${escapeHtml(host)}</a>`;
}

// Escape `text`, then replace each URL with a domain-only anchor. Returns an
// HTML string safe for innerHTML (only the matched anchors are live markup).
export function linkify(text) {
  const s = String(text == null ? '' : text);
  let out = '';
  let last = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(s)) !== null) {
    out += escapeHtml(s.slice(last, m.index));
    let url = m[0];
    let trail = '';
    const tm = url.match(TRAIL_RE);
    if (tm) { trail = url.slice(url.length - tm[0].length); url = url.slice(0, -tm[0].length); }
    out += anchor(url) + escapeHtml(trail);
    last = m.index + m[0].length;
  }
  out += escapeHtml(s.slice(last));
  return out;
}
